import { useEffect } from "react";
import "./Loader.css";

export default function Loader({ onFinish }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="loader-container">
      <img
        src="assets/ISTP_LOGO.png"
        alt="ISTP Overseas"
        className="loader-logo"
      />
    </div>
  );
}